import {
  deleteRole,
  EDITED_ROLE,
  editRole,
  loadPermissions,
  loadRoles,
  PERMISSION_LIST,
  propertyChange,
  ROLE_LIST,
  saveRole
} from "../../../ducks/role";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import RoleManagement from "./RoleManagement";
import { LANGUAGE } from "../../../ducks/languageSelector";
import { LANGUAGE_SELECTOR, ROLE_STORE } from "../../../common/constant";

const mapStateToProps = (state) => {
  return {
    roleList: state[ROLE_STORE][ROLE_LIST],
    permissionList: state[ROLE_STORE][PERMISSION_LIST],
    editedRole: state[ROLE_STORE][EDITED_ROLE],
    locale: state[LANGUAGE_SELECTOR][LANGUAGE]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadRoles,
      loadPermissions,
      editRole,
      saveRole,
      deleteRole,
      propertyChange
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleManagement);
